'use strict';
const AutoSuggestion = () => {
    var APIEndPoint= window.location.origin;
    var SearchPageURL = window.location.origin+'/search';
    const queryParams = new URLSearchParams(window.location.search);
    var querySearch = queryParams.get('s');
    const [searchData, setSearchData] = React.useState([]);
    const [searchDataProducts, setSearchDataproducts] = React.useState([]);
    const [error, setError] = React.useState('');
    const [searchQuery, setSearchQuery] = React.useState(querySearch?querySearch:''); 
    const [apiCallFlag, setApiCallFlag] = React.useState(false); 
    const [apidataFlag, setDataCallFlag] = React.useState(false); 

    //Global functions
    const getProductName = (pname) =>{
        var name = '';
        let re1 = /[^\w\d]/ig;
        name = pname.replace(re1, '-');

        let re2 = /[ ]/;
        name = name.replace(re2, '-');

        let re3 = /-+/g;
        name = name.replace(re3,'-');
        return name.toLowerCase();

    }
    function _AntiForgeryToken(id) {
        $.ajax({
            url: "/login/RefreshToken",
            type: "GET",
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('Content-Type', 'application/json');
            },
            success: function (data) {
                //console.log(data);
            },
            complete: function (data) {
                //console.log("Hello", data);
                $(id).html(data.responseText);
                // Set our complete callback, 
            },
            error: function (e) {
                //alert("error");
            }
        });
    }
    React.useEffect(() => {
        if(apiCallFlag==true && apidataFlag==false){
        var query='';
        const timeout = setTimeout(() => {
            const apiCallToGetSuggest = () =>{
                query = '';
                if(searchQuery !== null && searchQuery !== '' && searchQuery.length>=2){
                    query +='q='+encodeURIComponent(searchQuery);
                    setSearchData([]);
                    setSearchDataproducts([]);
                    var responseCode = '';
                    //suggestions
                    fetch(APIEndPoint +'/api/middys?name=suggest&'+query,{
                        method: 'GET',
                        headers: {
                            "RequestVerificationToken": $("#checkloginApi [name='__RequestVerificationToken']").val()
                        }
                    }).then(results => {
                        responseCode = results.status;
                        return results.json()
                    }
                    ).then(data => {
                        _AntiForgeryToken("#checkloginApi");
                        if(data.hasOwnProperty('StatusCode')){
                            if(data.StatusCode === 204){
                                setError('')
                            }else{
                                if(data.hasOwnProperty('ErrorMessage')){
                                    setError(data.ErrorMessage);
                                }
                            }  
                        }else{
                            setDataCallFlag(true);
                            if(data.hasOwnProperty("keywords")){
                                setSearchData(data.keywords);
                            }  
                            if(data.hasOwnProperty("products")){
                                setSearchDataproducts(data.products);
                            }  
                        }  
                    }, (error) => {
                        _AntiForgeryToken("#checkloginApi");
                        setError('Error while getting response');
                    });
                }else{
                    setDataCallFlag(false);
                    setSearchData([]);
                    setSearchDataproducts([]);
                }
            }
            apiCallToGetSuggest(1);
        }, 300)
        return () => clearTimeout(timeout)
    }
    }, [searchQuery,apiCallFlag,apidataFlag])
    


    React.useEffect(() => {
        const onScroll = () => {
            if(window.pageYOffset!==0){
                $("#searchForm").find('.autosuggest').hide();
            }
        }
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    function useOutsideAlerter(ref) {
        React.useEffect(() => {
          function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
              $("#searchForm").find('.autosuggest').hide();
            }
          }

          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, [ref]);
    }

    const wrapperRef = React.useRef(null);
    useOutsideAlerter(wrapperRef);

    const getSearchForm= (props) =>{
        const handleSearchQueryChange=(event)=>{
            setError('');
            if(event.target.value.length<=2){
                setSearchData([]);
                setSearchDataproducts([]);
            }
                setDataCallFlag(false);
                setApiCallFlag(true);
                setSearchQuery(event.target.value);
        }
        const handleSearchQueryEnter=(event)=>{
            if(event.key === 'Enter') {
                if(searchQuery.length>0){
                    if(searchQuery!== null && searchQuery !==''  && searchQuery.length>=2){
                        window.location.href = SearchPageURL+'?s='+encodeURIComponent(searchQuery);
                    }else{
                        setError('Please enter more than 1 character'); 
                    } 
                }
                else{
                    setError('Please enter a search query');
                } 
            }
        }
        const handleSearchButtonClick = () =>{
            if(searchQuery.length>0){
                if(searchQuery!== null && searchQuery !=='' && searchQuery.length>=2){
                    window.location.href = SearchPageURL+'?s='+encodeURIComponent(searchQuery);
                }else{
                    setError('Please enter more than 1 character');
                }
            }else{
                setError('Please enter a search query');
            }      
        }

        return (
         
            <div ref={wrapperRef} >
                <input 
                    type="search"
                    name="head-search" 
                    value={searchQuery}
                    className={`autocomplete ${searchQuery!==''?'active':''}`}
                    id="head-search" 
                    onKeyDown={handleSearchQueryEnter}
                    onChange={handleSearchQueryChange}
                    placeholder="Search products"
                    onFocus={() => {
                        searchData.length>0 || searchDataProducts.length>0 ? $("#searchForm").find('.autosuggest').show() : setApiCallFlag(true)
                    }}
                    autoComplete="off"
                    />
                <input type="submit" name="head-submit" id="head-submit" value="" onClick={handleSearchButtonClick}/>
                {searchQuery && searchQuery!='' && searchQuery.length>=2?
                    <div className="autosuggest" style={{display:searchData.length >0 || searchDataProducts.length>0?'block':'none'}}>
                        
                        <div className="popular-searches">
                            <label>POPULAR SEARCHES</label>
                            {searchData.length>0?
                            <ul>
                                {searchData.map((search,index)=>(
                                    <li key={index}>
                                        <a  href={`${window.location.origin}/search?s=${search.suggestion}`} >{search.suggestion}</a>
                                    </li>
                                ))}
                            </ul>
                            :
                            <ul>
                                <li>
                                    <a  href="#"><i>No Results</i></a>
                                </li>
                            </ul>
                            }
                        </div>
                        <div className="matches">
                            <label>PRODUCT MATCHES</label>
                            {searchDataProducts.length>0?
                            <ul>
                                {searchDataProducts.map((product,index)=>(
                                    
                                <li key={index}>
                                    <a href={`/p/${product.hasOwnProperty('product_display_name')?product.product_display_name.hasOwnProperty('raw')?getProductName(product.product_display_name.raw):null:null}/${product.hasOwnProperty('product_pronto_code')?product.product_pronto_code.hasOwnProperty('raw')? product.product_pronto_code.raw:null:null}`}>
                                        <span className="attached-image">
                                            {product.hasOwnProperty('product_images')?
                                                product.product_images.hasOwnProperty('raw')?
                                                    product.product_images.raw.length>0?
                                                        <img src={product.product_images.raw[0]+'?f=jpg&w=50&h=50'} alt={product.hasOwnProperty('product_name')?product.product_name.hasOwnProperty('raw')?product.product_name.raw:"Product":"Product"} />
                                                    :<img src="/images/product-default.png" alt={product.hasOwnProperty('product_name')?product.product_name.hasOwnProperty('raw')?product.product_name.raw:"Product":"Product"} />
                                                :<img src="/images/product-default.png" alt={product.hasOwnProperty('product_name')?product.product_name.hasOwnProperty('raw')?product.product_name.raw:"Product":"Product"} />
                                            :<img src="/images/product-default.png" alt={product.hasOwnProperty('product_name')?product.product_name.hasOwnProperty('raw')?product.product_name.raw:"Product":"Product"} />
                                            }
                                        </span>
                                        {product.hasOwnProperty('product_display_name')?
                                            product.product_display_name.hasOwnProperty('raw')?
                                                product.product_display_name.raw
                                            :null
                                        :null}
                                    </a>
                                </li>
                                ))} 
                            </ul>
                            :
                            <ul>
                                <li>
                                    <a  href="#"><i>No Results</i></a>
                                </li>
                            </ul>    
                            }
                        </div>
                        
                    </div>  
                :null}
			</div>
 
        )

    }
    return (getSearchForm());     
}
ReactDOM.render(<AutoSuggestion/>, document.querySelector("#searchForm"));